import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import {
  API_URL,
  MaleUrl,
  optionChart,
  optionsXaxisAxisBorder,
  optionsXaxisAxisTicks,
  optionsXaxisLabels,
  PAGECOUNT
} from '../../config/const'
import StarRatingCustom from '../../components/control/star_rating'
import ReactApexChart from 'react-apexcharts'
import TabHeader from '../../components/control/table/tab_header'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import PerfectScrollbar from 'react-perfect-scrollbar'
import ReactPaginate from 'react-paginate'
import {customDateFormat, drawTableBJPointCell, drawTableTitleCell, drawTableArticleType, formatNumber, fphoto, string} from '../../helper/common'
import tbAnalystHeaders, {tbBjHeaders, tbDailyHeaders, tbGameHeaders} from '../../config/constTable'
import ConfirmButton from '../../components/control/button/confirm_button'
import {rootStore} from '../../mobx/store'
import ItemBuy from '../../components/item/item_buy'
import TableCellGameCate from '../../components/control/table/table_cell_game_cate'
import { RESULT_CODE } from '../../config/const'
import { requestBjDataBuy } from '../../helper/business'
const AnalystDetail = observer((props) => {
  let {info, wineeList} = props.location.state
  const mb_lv = info?.mb_lv ?? 0

  const context = useContext(Page_settings)
  let [mbInfo, setMbInfo] = useState(info)
  let [tabIndex, setTabIndex] = useState(0)
  let [dataList, setDataList] = useState([[], [], [], [], [], []])
  let [itemList, setItemList] = useState([])
  let [itemIndex, setItemIndex] = useState(0)
  let [pageCount, setPageCount] = useState([1, 1, 1, 1, 1, 1])
  let [page, setPage] = useState([1, 1, 1, 1, 1, 1])
  const tabList = [strings.proto_game_analyst, strings.proto_betting, strings.proto_victory1, strings.daily_special, strings.pm_game, strings.eve_game]
  let [type, setType] = useState(mb_lv == 3 ? 1 : 0)
  let [selBj, setSelBj] = useState(info?.mb_id ?? 0)
  let [memberList, setMemberList] = useState(wineeList)

  useEffect(() => {
    if (info == null) {
      props.history.back()
    }
    setInfo(info)
  }, [])

  useEffect(() => {
    getData(info.mb_id, 1, tabIndex)
    if (tabIndex !== 3) return
    context.checkDailyPopup()
  }, [tabIndex])

  const setInfo = (info) => {
    context.post('data/bj_ticket_cnt', {mb_id: info.mb_id},
      response => {
        let ticket = response.readable_cnt
        info.readable_cnt = ticket
        setMbInfo(info)
        setReadableCnt(ticket)
      },
      false,
      err => {
        if (err.result !== RESULT_CODE.TOKEN_EXPIRED)
          setTimeout(() => {context.showAlert(err.msg)}, 500)
      }
    )

    let itList = []
    if (info.price01 > 0) itList.push({it_id: 1, it_name: strings.one_day_package, it_price: info.price01})
    if (info.price10 > 0) itList.push({it_id: 10, it_name: strings.ten_day_package, it_price: info.price10})
    if (info.price20 > 0) itList.push({it_id: 20, it_name: strings.twenty_day_package, it_price: info.price20})
    if (info.price30 > 0) itList.push({it_id: 30, it_name: strings.thirty_day_package, it_price: info.price30})
    setItemList(itList)
  }

  const getData = (mb_id, page, index) => {
    let indexes = [1, 2, 3, 6, 4, 5]
    context.post('data/data_list', {mb_id: mb_id, cate: indexes[index], page: page, count: PAGECOUNT},
      response => {
        if (rootStore.isSignedIn) {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
        }
        setDataList(prev => prev.map((it, idx) => {return idx === index ? response.list : it}))
        setPageCount(prev => prev.map((it, idx) => {return idx === index ? response.page_count : it}))
      },
      false
    )
  }

  const onLike = () => {
    const status = 1 - mbInfo.mb_is_like
    context.onLike(mbInfo, status, false, () => {
      setMbInfo({...mbInfo, mb_is_like : status})
    })
  }

  const setReadableCnt = (cnt) => {
    mbInfo.readable_cnt = cnt
    // setMbInfo(mbInfo)
    setMemberList(prev => prev.map((it) => {
      if (it.mb_id == mbInfo.mb_id) it.readable_cnt = cnt
      return it
    }))
    const idx = mbInfo.mb_lv == 3 ? 1 : 0
    wineeList = wineeList.map((it) => {
      if (it.mb_id == mbInfo.mb_id) it.readable_cnt = cnt
      return it
    })
  }

  const onBuyItem = () => {
    if (!rootStore.isSignedIn) {
      props.history.push('/login')
      return
    }

    const item = itemList[itemIndex]
    if (item.it_price == 0) return
    context.showConfirm(strings.ask_package, (val) => {
      if (!val) return
      const mb_point = rootStore.getMe.mb_point
      if (Number(mb_point) < Number(item.it_price)) {
        context.showPointLack(2, item.it_price, () => {
          context.showPointPay()
        })
        return
      }
      context.post('pay/bj_buy', {bj_id: mbInfo.mb_id, limit: item.it_id},
        response => {
          let mb = rootStore.getMe
          mb.mb_point = response.mb_point
          rootStore.signIn(mb)
          setReadableCnt(response.readable_cnt)
          setTimeout(() => {context.showAlert(strings.package_bought)}, 500)
        },
        true,
        err => {
          setTimeout(() => {context.showAlert(err.msg)}, 500)
        }
      )
    })
  }

  const goResult = (result) => {
    let urls = ['/analyst/game_detail', '/analyst/betting_detail', '/analyst/victory_detail', '/analyst/daily_detail', '/bj/bj_result', '/bj/bj_result']
    props.history.push(urls[tabIndex], {result: result})
  }

  const onResultAnalyst = (result, price) => {
    if (!rootStore.isSignedIn) {
      props.history.push('/login')
      return
    }

    if (result.is_readable == 0) {
      context.showAlert(strings.data_disabled)
      return
    }

    if (result.is_purchased == 0) {
      context.showPointUse(result.mb_nick, price, () => {
        const mb_point = rootStore.getMe.mb_point
        if (Number(mb_point) < Number(price)) {
          context.showPointLack(1, price, () => {
            context.showPointPay()
          })
          return
        }
        context.post('pay/andata_buy', {dat_id: result.dat_id},
          response => {
            let mb = rootStore.getMe
            mb.mb_point = response.mb_point
            rootStore.signIn(mb)
            goResult(result)
          },
          true,
          err => {
            setTimeout(() => {context.showAlert(err.msg)}, 500)
          }
        )
      })
      return
    }
    goResult(result)
  }

  const onResultBj = (result) => {
    requestBjDataBuy(context, result, props, ()=>goResult(result));
  }

  const handlePageClick = (component) => {
    let nextPage = component.selected + 1
    setPage(prev => prev.map((it, idx) => {return idx === tabIndex ? nextPage : it}))
    getData(mbInfo.mb_id, nextPage, tabIndex)
  }

  const setAnalyst = (idx) => {
    if (type === idx) return
    setType(idx)
    setMemberList(wineeList)
  }

  const selectBj = (mb_id) => {
    if (mb_id == mbInfo.mb_id) return

    if (mb_id === 0) {
      props.history.push('/analyst/list')
      return
    }
    setSelBj(mb_id)
    const bj = memberList.filter((item) => {return item.mb_id == mb_id})
    if (bj.length > 0) setInfo(bj[0])
  }

  const onDetail = (info) => {
    const idx = info.mb_lv == 3 ? 1 : 0
    setAnalyst(idx)
    let mb
    mb = wineeList.filter((item) => {return item.mb_id == info.mb_id})
    if (mb.length > 0) setInfo(mb[0])
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft type={2} wineeList={wineeList} onWinee={(info) => {onDetail(info)}} history={props.history} />
        <div className='im-container v-analyst-detail'>
          <PageSubHeader className={'sm-none'} pageName={strings.analyst_winee} pageMenu1={strings.main} pageMenu2={strings.analyst_winee}/>
          <div className='sm-inherit'>
            <div className='d-flex align-items-center'>
              <div className={'sm-fs-20 f-b cursor-point'}>{strings.analyst_winee}</div>
            </div>
          </div>
          <select className='form-control sm-inherit custom_select mt-15' value={selBj} onChange={(e) => {selectBj(parseInt(e.target.value))}}>
            <option value={0}>{strings.all}</option>
            {memberList && memberList.map((it, idx) => {return (<option value={it.mb_id} key={idx}>{it.mb_nick}</option>)})}
          </select>
          <div className='bj-detail-area mt-30 sm-mt-15'>
            <div className='flex-full'>
              <div className='winee-bj-item-area sm-mt-15'>
                <div className='d-flex justify-content-center winee-bj-item-area-main'>
                  <div className='flex-full'>
                    <div className='d-flex align-items-center'>
                      <img className='winee-bj-profile' src={fphoto(mbInfo.mb_photo, 'member', MaleUrl)} alt={''} />
                      <div className='ml-20 mt-auto mb-auto'>
                        <div className='fs-20 sm-fs-16 f-b color-3a3335'>{strings.member + ' ' + mbInfo.mb_nick}{mbInfo.mb_new == 1 && <img className='icon_new' src='/assets/image/new.png' alt=''/>}</div>
                        <div className='fs-14 sm-fs-12 f-m color-4c4c4d'>{mbInfo.mb_intro}</div>
                      </div>
                    </div>
                    <div className='d-flex align-items-center mt-8'>
                      <div className='fs-12 color-4c4c4d flex-full'>{strings.active_period}&nbsp;&nbsp;{mbInfo.mb_createdat.dateFormat('YYYY.MM.DD')}</div>
                      <div className='fs-12 color-4c4c4d flex-full'>{strings.intro_avg_upload}&nbsp;&nbsp;{mbInfo.mb_avgUpload}</div>
                      <div className='btn-bj-like cursor-point d-center sm-inherit' onClick={onLike}>
                        <img className='star-img' src={mbInfo.mb_is_like === 1 ? '/assets/image/like_on.png' : '/assets/image/like.png'} alt=''/>
                        <div className='fs-14 sm-fs-12 f-m ml-12'>{strings.add_like}</div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div className='btn-bj-like cursor-point d-center sm-none' onClick={onLike}>
                      <img className='star-img' src={mbInfo.mb_is_like === 1 ? '/assets/image/like_on.png' : '/assets/image/like.png'} alt=''/>
                      <div className='fs-14 sm-fs-12 f-m ml-12'>{strings.add_like}</div>
                    </div>
                  </div>
                </div>
                <div className=''>
                  <div className='flex-full position-relative'>
                    <div className='fs-14 f-b mt-20 color-3a3335'>{strings.intro}</div>
                    <div className='fs-14 mt-14 color-4c4c4d space-break bj-intro' dangerouslySetInnerHTML={{ __html: mbInfo.mb_detail }} />
                    {/* <div className='winee-bj-rate-area winee-analyst-detail-rate-area mt-20 d-flex position-relative'>
                      <div className='flex-full d-center'>
                        <div>
                          <StarRatingCustom
                            disabled={true}
                            starCnt={mbInfo.mb_sale_rate}
                            size={18}
                          />
                          <div className='mt-2 fs-14 sm-fs-12 text-center color-4c4c4d'>{strings.week_sale}</div>
                        </div>
                      </div>
                      <div className='title-divider1 height-full' />
                      <div className='flex-full d-center'>
                        <div>
                          <StarRatingCustom
                            disabled={true}
                            starCnt={mbInfo.mb_period_rate}
                            size={18}
                          />
                          <div className='mt-2 fs-14 sm-fs-12 text-center color-4c4c4d'>{strings.week_hit}</div>
                        </div>
                      </div>
                      <div className='title-divider1 height-full' />
                      <div className='flex-full d-center'>
                        <div>
                          <StarRatingCustom
                            disabled={true}
                            starCnt={mbInfo.mb_five_rate}
                            size={18}
                          />
                          <div className='mt-2 fs-14 sm-fs-12 text-center color-4c4c4d'>{strings.recent_5_hit}</div>
                        </div>
                      </div>
                    </div> */}
                  </div>
                  <div className='flex'>
                    <div className='fs-14 f-b mt-20 sm-mt-30 color-3a3335'>{strings.main_pro}</div>
                    <div className='mt-14 d-flex sm-block'>
                      {mbInfo.top_hit_list.map((it, idx) => {
                        return (
                          <div className='flex-full d-flex align-items-center' key={idx}>
                            <img className='' src={API_URL + '/assets/image/' + it.sk_icon} alt='' width={18} height={18}/>
                            <div className='fs-12 f-m color-4c4c4d ml-8'>{it.sk_name}</div>
                            <div className='fs-15 f-b color-4c4c4d ml-4 text-decoration-underline'>{it.hit_rate + strings.match_pro}</div>
                          </div>
                        )
                      })}
                    </div>
                    <div className='d-flex-block'>
                      <div className='w-50 sm-w-100'>
                        <div className='mt-10 sm-mt-15 winee-bj-chart-area'>
                          <ReactApexChart type='area' options={{ ...optionChart, xaxis: {categories: mbInfo.mb_game_label_list, axisBorder: optionsXaxisAxisBorder, axisTicks: optionsXaxisAxisTicks, labels: optionsXaxisLabels}}} series={[{name: strings.hit, data: mbInfo.mb_game_hit_list}]} height={130} />
                        </div>
                        <div className='winee-bj-chart-guide fs-12 f-m text-center'>{strings.chat_game}</div>
                      </div>
                      <div className='w-50 sm-w-100 ml-8 sm-ml-0'>
                        <div className='mt-10 sm-mt-15 winee-bj-chart-area'>
                          <ReactApexChart type='area' options={{ ...optionChart, xaxis: {categories: mbInfo.mb_betting_label_list, axisBorder: optionsXaxisAxisBorder, axisTicks: optionsXaxisAxisTicks, labels: optionsXaxisLabels}}} series={[{name: strings.hit, data: mbInfo.mb_betting_hit_list}]} height={130} />
                        </div>
                        <div className='winee-bj-chart-guide fs-12 f-m text-center'>{strings.chat_betting}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* remove unnecessary component */}|
            {/* <div className='ml-20 sm-ml-0 sm-mt-15 term-content-area bj-item-area mt-0 mb-0'>
              <div className='fs-20 sm-fs-16 f-b color-3a3335'>{strings.item_buy}{rootStore.isSignedIn && rootStore.getMe.mb_id != mbInfo.mb_id && <span className='fs-18 f-b mt-20 color-fa2222 ml-10'>{string.Format(strings.ticket_cnt, formatNumber(mbInfo.readable_cnt))}</span>}</div>
              <ItemBuy
                className={'mt-40 sm-mt-14'}
                list={itemList}
                selected={itemIndex}
                onClick={(idx) => {setItemIndex(idx)}}
              />
              <div className='fs-15 mt-35 sm-mt-30 color-4c4c4d'>{mbInfo.an_note}</div>
              {itemList.length > 0 && (rootStore.getMe?.mb_id ?? 0) != mbInfo.mb_id && <ConfirmButton enabled={true} className={'btn-bottom fs-15 f-m d-center mt-40'} onClick={onBuyItem} text={strings.buying} />}
            </div> */}
            
          </div>
          <div className='fs-20 sm-fs-16 f-b mt-60 sm-mt-35 color-3a3335'>{strings.analyst_data}</div>
          <TabHeader className={'mt-20 sm-none'} selected={tabIndex} tabs={tabList} onChange={(id) => {setTabIndex(id)}}/>
          <select className='form-control sm-mt-14 sm-inherit custom_select' value={tabIndex} onChange={(e) => {setTabIndex(parseInt(e.target.value))}}>
            {tabList.map((it, idx) => {return (<option value={idx} key={idx}>{it}</option>)})}
          </select>
          {tabList.map((it, idx) => {return (
            <div key={idx} className={tabIndex === idx ? '' : 'hide'}>
              <div className='shadow-div position-relative'>
                <PerfectScrollbar className='tb-sale sm-mt-20 mb-40'>
                  <TableHeader className={'bg-white'} headers={idx > 3 ? tbBjHeaders : (idx === 3 ? tbDailyHeaders: (idx === 0 ? tbGameHeaders : tbAnalystHeaders))}/>
                  {
                    idx === 0 && dataList[idx].map((info, index) => {
                      return (
                        <div key={index} className='tb-row cursor-point' onClick={() => {onResultAnalyst(info, info.dat_po )}}>
                          <TableCell
                            value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                            className={tbGameHeaders[0].class}
                            center={tbGameHeaders[0].center}
                            child={null}
                          />
                          <TableCellGameCate
                            icon={info.sk_icon}
                            name={info.sk_name}
                            className={tbGameHeaders[1].class + ' d-flex'}
                            center={tbGameHeaders[1].center}
                            child={null}
                          />
                          <TableCell
                            value={customDateFormat(info.dat_start)}
                            className={tbGameHeaders[2].class}
                            center={tbGameHeaders[2].center}
                            child={null}
                          />
                          <TableCell
                            value={info.home_name + ' : ' + info.away_name}
                            className={tbGameHeaders[3].class}
                            center={tbGameHeaders[3].center}
                            child={null}
                          />
                          <TableCell
                            value={info.dat_title}
                            className={tbGameHeaders[4].class}
                            center={tbGameHeaders[4].center}
                            child={drawTableTitleCell(info.dat_title, info.data_new)}
                          />
                          <TableCell
                            value={info.mb_nick}
                            className={tbGameHeaders[5].class}
                            center={tbGameHeaders[5].center}
                            child={null}
                          />
                          <TableCell
                            value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
                            color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color: strings.no_buy_color)}
                            className={tbGameHeaders[6].class}
                            center={tbGameHeaders[6].center}
                            child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)}
                          />
                        </div>
                      )
                    })
                  }
                  {
                    idx > 0 && idx < 3 && dataList[idx].map((info, index) => {
                      return (
                        <div key={index} className='tb-row cursor-point' onClick={() => {onResultAnalyst(info, info.dat_po )}}>
                          <TableCell
                            value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                            className={tbAnalystHeaders[0].class}
                            center={tbAnalystHeaders[0].center}
                            child={null}
                          />
                          <TableCell
                            value={customDateFormat(info.dat_start)}
                            className={tbAnalystHeaders[1].class}
                            center={tbAnalystHeaders[1].center}
                            child={null}
                          />
                          <TableCellGameCate
                            icon={info.sk_icon}
                            name={info.sk_name}
                            className={tbGameHeaders[1].class + ' d-flex'}
                            center={tbGameHeaders[1].center}
                            child={null}
                          />
                          <TableCell
                            value={info.dat_title}
                            className={tbAnalystHeaders[3].class}
                            center={tbAnalystHeaders[3].center}
                            child={drawTableTitleCell(info.dat_title, info.data_new)}
                          />
                          <TableCell
                            value={info.mb_nick}
                            className={tbAnalystHeaders[4].class}
                            center={tbAnalystHeaders[4].center}
                            child={null}
                          />
                          <TableCell
                            value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
                            color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color: strings.no_buy_color)}
                            className={tbAnalystHeaders[5].class}
                            center={tbAnalystHeaders[5].center}
                            child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)}
                          />
                        </div>
                      )
                    })
                  }
                  {
                    idx === 3 && dataList[idx].map((info, index) => {
                      return (
                        <div key={index} className='tb-row cursor-point' onClick={() => {onResultAnalyst(info, info.dat_po )}}>
                          <TableCell
                            value={info.dat_s_year + strings.year + ' ' + info.dat_s_round + strings.times}
                            className={tbDailyHeaders[0].class}
                            center={tbDailyHeaders[0].center}
                            child={null}
                          />
                          <TableCellGameCate
                            icon={info.sk_icon}
                            name={info.sk_name}
                            className={tbGameHeaders[1].class + ' d-flex'}
                            center={tbGameHeaders[1].center}
                            child={null}
                          />
                          <TableCell
                            value={customDateFormat(info.dat_start)}
                            className={tbDailyHeaders[2].class}
                            center={tbDailyHeaders[2].center}
                            child={null}
                          />
                          <TableCell
                            value={info.dat_title}
                            className={tbDailyHeaders[3].class}
                            center={tbDailyHeaders[3].center}
                            child={drawTableTitleCell(info.dat_title, info.data_new)}
                          />
                          <TableCell
                            value={info.mb_nick}
                            className={tbDailyHeaders[4].class}
                            center={tbDailyHeaders[4].center}
                            child={null}
                          />
                          <TableCell
                            value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
                            color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color: strings.no_buy_color)}
                            className={tbDailyHeaders[4].class}
                            center={tbDailyHeaders[4].center}
                            child={drawTableBJPointCell(info.dat_po, info.dat_po, info.is_purchased, info.is_readable)}
                          />
                        </div>
                      )
                    })
                  }
                  {
                    idx > 3 && dataList[idx].map((info, index) => {
                      return (
                        <div key={index} className='tb-row cursor-point' onClick={() => {onResultBj(info)}}>
                         <TableCell
                            value={null}
                            className={tbBjHeaders[0].class}
                            center={tbBjHeaders[0].center}
                            child={drawTableArticleType(info.dat_cate)}
                          />
                          <TableCell
                            value={customDateFormat(info.dat_start)}
                            className={tbBjHeaders[1].class}
                            center={tbBjHeaders[1].center}
                            child={null}
                          />
                          <TableCell
                            value={info.dat_title}
                            className={tbBjHeaders[2].class}
                            center={tbBjHeaders[2].center}
                            child={drawTableTitleCell(info.dat_title, info.data_new)}
                          />
                          <TableCell
                            value={info.mb_nick}
                            className={tbBjHeaders[3].class}
                            center={tbBjHeaders[3].center}
                            child={null}
                          />
                          <TableCell
                            value={info.is_purchased == 1 ? strings.free_price : (info.is_readable == 0 ? strings.disable_buy : strings.no_buy)}
                            color={info.is_purchased == 1 ? null : (info.is_readable == 0 ? strings.disable_buy_color: strings.no_buy_color)}
                            className={tbBjHeaders[4].class}
                            center={tbBjHeaders[4].center}
                            child={null}
                          />
                        </div>
                      )
                    })
                  }
                </PerfectScrollbar>
              </div>
              {pageCount[idx] > 1 &&
              <ReactPaginate
                previousLabel={''}
                nextLabel={''}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={pageCount[idx]}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                subContainerClassName={'pages pagination'}
                activeClassName={'active'}
              />
              }
            </div>
          )})}
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(AnalystDetail)
